import React from 'react';
import '../components/HomeView/Home.css'
import {TopMenuLinks} from "../components/HomeView/TopMenuLinks";
import {TopMenuLogo} from "../components/HomeView/TopMenuLogo";
import {PaintingItem} from "../components/PaintingView/PaitingItem";
import ObLifeguardStation1 from './../img/paintings/IMG_5297.jpg'

import surfAndSkateLogo from './../img/sales/obSurfAndSkate.png'
import vignettesLogo from './../img/sales/vignettes.png'
import sunshineLogo from './../img/sales/sunshineLogo.jpg'

import pic2 from './../img/paintings/IMG_4800.jpg'
import pic3 from './../img/paintings/IMG_5246.jpg'
import pic4 from './../img/paintings/IMG_5263.jpg'
import pic5 from './../img/paintings/IMG_5286.jpg'

import pic6 from './../img/paintings/IMG_1.jpg'
import pic7 from './../img/paintings/IMG_2.jpg'
import pic8 from './../img/paintings/IMG_3.jpg'
import pic9 from './../img/paintings/IMG_4.jpg'
import pic10 from './../img/paintings/IMG_5.jpg'
import pic11 from './../img/paintings/IMG_6.jpg'
import pic12 from './../img/paintings/IMG_7.jpg'
import pic13 from './../img/paintings/IMG_8.jpg'
import pic14 from './../img/paintings/IMG_9.jpg'
import pic15 from './../img/paintings/IMG_10.jpg'
import pic16 from './../img/paintings/IMG_11.jpg'
import pic17 from './../img/paintings/IMG_12.jpg'
import {MobileSearchBar} from "../components/HomeView/MobileSearchBar";
import ProductEmbed from "./ProductEmbed";
import ShopifyProductEmbed from "./ShopifyProductEmbed";
import NewShopifyProductEmbed from "./NewShopifyProductEmbed";
import {PartnerImageLink} from "../components/SalesView/PartnerImageLink";


export const SalesView = () => {

    return <div className='PageBackground'>
        <TopMenuLogo/>
        <MobileSearchBar/>
        <TopMenuLinks/>
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            height: '100%',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {/*message*/}
            <div style={{backgroundColor: 'rgb(48,93,150)', width: '100%', padding: '1%', marginBottom: '2.5%'}}>
                <div style={{textAlign: 'center', fontSize: 18, color: 'white'}}>If you love it, you should own it.
                    Reproduction watercolor postcards and original art!
                </div>
            </div>

            <div style={{backgroundColor: 'rgb(48,93,150)', width: '80%', padding: '1%', marginBottom: '2.5%', border: '3px solid rgb(134,180,99)'}}>
                <div style={{textAlign: 'center', fontSize: 18, color: 'white', fontWeight: 'bold', marginBottom: '1.5%'}}>Now available at these wonderful retail
                    locations!
                </div>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '16px',
                    // justifyContent: 'flex-start',
                    // display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                }}><PartnerImageLink src={vignettesLogo} link={'https://vignettesdecor.com/'} alt={'Vignettes Decor'}/>
                    <PartnerImageLink src={surfAndSkateLogo} link={'https://www.obsurfandskate.com/'}
                                      alt={'Ocean Beach Surf and Skate'}/>
                    <PartnerImageLink src={sunshineLogo}
                                      link={'https://directory.oceanbeachsandiego.com/go/sunshine-daydreams'}
                                      alt={'SunShine DayDreams'}/></div>
            </div>


            {/*<ProductEmbed/>*/}
            <NewShopifyProductEmbed productId="9014023880948"
                                    componentId={"9014023880948"}/>
            <NewShopifyProductEmbed productId="9014023717108"
                                    componentId={"9014023717108"}/>
            <NewShopifyProductEmbed productId="9014023291124"
                                    componentId={"9014023291124"}/>
            {/*<NewShopifyProductEmbed productId="9014024896756"*/}
            {/*                        componentId={"9014024896756"}/>*/}
            <NewShopifyProductEmbed productId="9025730183412"
                                    componentId={"9025730183412"}/>
            <NewShopifyProductEmbed productId="9283610247412"
                                    componentId={"9283610247412"}/>
        </div>
    </div>
}

